import React, { useState, useEffect } from 'react';
import { Button, View, Flex, Text } from '@smarterservices/smarter-ui';
import { focusExamTab } from '@session/helpers/helpers';

const OtherTabMenu = () => {
  const [onboardingComplete, setOnboardingComplete] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const url = new URL(window.location.href);
    const params = new URLSearchParams(url.search);
    const isOnboardingComplete = params.get('isOnboardingComplete');
    console.log('Is Onboarding Complete:', isOnboardingComplete === 'true');

    setOnboardingComplete(isOnboardingComplete === 'true');
    setLoading(false);

    const handleMessage = (event) => {
      console.log('[OtherTabMenu] Received message event:', {
        source: event.source === window.parent ? 'window.parent' : 'other',
        data: event.data,
        origin: event.origin
      });

      // Listen for messages from parent (the wrapper)
      if (event.data?.source === 'SmarterProctoringExtensionMessenger') {
        const payload = event.data?.payload;

        if (!payload || !payload?.message) {
          return;
        }

        if (payload.message === 'updateSpOnboardingComplete') {
          setOnboardingComplete(true);
        }
      }
    };

    window.addEventListener('message', handleMessage);

    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, []);

  const handleButtonClick = () => {
    focusExamTab();
  };

  if (loading) {
    return null;
  }

  const statusText = onboardingComplete
    ? 'SecureSession Active'
    : 'SecureSession Onboarding Incomplete';

  const buttonText = onboardingComplete
    ? 'Return to Exam'
    : 'Return to Onboarding';

  return (
    <View
      background="brand"
      width="100%"
      height="30px"
      padding="xx-small small"
      display="flex"
      alignItems="center"
    >
      <Flex
        direction="row"
        width="100%"
      >
        <Flex.Item shouldGrow shouldShrink margin="xx-small 0 x-small 0">
          <Text
            color="primary-inverse"
            size="x-small"
            weight="bold"
          >
            {statusText}
          </Text>
        </Flex.Item>

        <Flex.Item margin="xx-small 0 x-small 0">
          <Button
            color="primary-inverse"
            size="small"
            onClick={handleButtonClick}
            margin="0"
            withBackground={true}
            themeOverride={{
              smallFontSize: '0.625rem',
              primaryInverseColor: '#0374B5',
            }}
          >
            {buttonText}
          </Button>
        </Flex.Item>
      </Flex>
    </View>
  );
};

export default OtherTabMenu;
